import React from 'react';
import { string } from 'prop-types';
import { Box } from '@styleseat/ui';
import { Textarea } from '../../../ui/TextInput';
import Label from './Label';

export default function TextAreaRow({ name, placeholder, ...restProps }) {
  return (
    <Textarea
      appearance="stretched"
      label={<Box paddingX={12}><Label>{name}</Label></Box>}
      name="name"
      placeholder={placeholder}
      {...restProps}
    />
  );
}

TextAreaRow.propTypes = {
  name: string.isRequired,
  placeholder: string.isRequired,
};
